import m from "./_copyObject.js";
import r from "./_getSymbols.js";
function f(o, t) {
  return m(o, r(o), t);
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_copySymbols.js
// module id = 1457
// module chunks = 41